export default "__VITE_ASSET__BVOAzfUd__"